module.exports = __webpack_public_path__ + "images/my-own-2521805694123c7878b4446bf7f30126.jpg";